import { ArrowLeft } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import styles from './PlaceholderPage.module.css';

interface Props {
  title: string;
  eyebrow: string;
  description: string;
  icon: LucideIcon;
  /** Where the Back button returns to. Defaults to /profile. */
  backPath?: string;
  onNavigate: (path: string) => void;
}

/**
 * Shared shell for pages on the Profile menu that don't have a dedicated
 * implementation yet. Gives users a consistent "coming soon" surface rather
 * than a dead route that falls through to the map.
 */
export function PlaceholderPage({
  title, eyebrow, description, icon: Icon, backPath = '/profile', onNavigate,
}: Props) {
  return (
    <div className={styles.page}>
      <button className={styles.back} onClick={() => onNavigate(backPath)}>
        <ArrowLeft size={14} /> Back
      </button>

      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <Icon size={28} />
        </div>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.desc}>{description}</p>

        <div className={styles.badge}>Coming soon</div>
      </div>
    </div>
  );
}
